import axios from 'axios';
import { LanguageObject } from '@/i18n';
import { Role } from './RoleUtils';
import { OversightOrganization } from './OversightUtils';
import { ServiceProvider } from './ProviderUtils';

type UserState = 'active' | 'inactive' | 'reset_password' | 'suspended';

interface Permission {
  id?: number;
  role: Partial<Role>;
  oversight?: Partial<OversightOrganization> | null;
  serviceprovider?: Partial<ServiceProvider> | null;
}
interface User {
  id?: number;
  firstname: string;
  lastname: string;
  username: string;
  password: string;
  email: string;
  state: UserState;

  coordinates: {}; // TODO: JSON
  preferences: {}; // TODO: JSON
  permissions: Partial<Permission>[];

  language?: string;
}

interface UserDisplayList extends User {
  roles?: LanguageObject[];
  oversightorgs?: LanguageObject[];
  serviceproviders?: LanguageObject[];
  name: string;
  lastlogin?: string;
  lastloginFromNow?: string;
}

const api = {
  list: async () => {
    const resp = await axios.get<UserDisplayList[]>('/user/list.php');
    return resp.data;
  },

  get: async (id: number) => {
    const resp = await axios.get<User>('/user/get.php', {
      params: { id: id },
    });
    return resp.data;
  },

  add: async (user: User) => {
    const resp = await axios.post<{ id: number }>('/user/add.php', user);
    return resp.data.id;
  },

  update: async (user: Partial<User>) => {
    await axios.post('/user/update.php', user);
  },

  remove: async (id: number) => {
    await axios.delete('/user/delete.php', {
      params: { id: id },
    });
  },
};

export default {
  api,
};
export { User, Permission, UserDisplayList };
